import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
import React, { useState } from 'react';
import Modal from '../../../../components/Modal';
import Button from '../../../../components/Button';
import appList from '../../../../config/apps';
import { activateProduct } from '../../../../api/activate-product';
import { PRODUCT_STATUS } from '../AppSwitcher/productsStatus';
import { ActivationContent } from './ActivationContent';
import Message from '../../../../components/Message/Message';
import parseUrl from 'url-parse';
import { requestAccess } from '../../../../api/request-access';
export var ActivationModal = function ActivationModal(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isLoading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      messageType = _useState4[0],
      setMessageType = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isAccessRequested = _useState6[0],
      setIsAccessRequested = _useState6[1];

  var originProduct = props.originProduct,
      targetProduct = props.targetProduct,
      productStatus = props.productStatus,
      isOpen = props.isOpen,
      onClose = props.onClose,
      swicusOrgId = props.swicusOrgId,
      environment = props.environment;
  return /*#__PURE__*/React.createElement(Modal, {
    "data-qa": "activation-modal-".concat(targetProduct),
    className: "activation-modal",
    open: isOpen,
    onClose: closeModal,
    closeIcon: true,
    size: "large"
  }, /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement(ActivationContent, {
    product: targetProduct,
    productStatus: productStatus
  }), messageType === 'error' && /*#__PURE__*/React.createElement(Message, {
    error: true,
    "data-qa": "activation-error-message"
  }, /*#__PURE__*/React.createElement(Message.Header, null, "Something went wrong"), /*#__PURE__*/React.createElement("p", null, "Please try again and if the problem persists, ", getContactLink(), ".")), messageType === 'success' && /*#__PURE__*/React.createElement(Message, {
    positive: true,
    header: "Your access request was sent to your Organization Owner",
    content: "You will receive an email once your request has been accepted.",
    "data-qa": "activation-success-message"
  })), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(ActionButtons, {
    isAccessRequested: isAccessRequested,
    targetProduct: targetProduct,
    productStatus: productStatus,
    onClose: closeModal,
    onActionButtonClick: processProductActivation,
    isLoading: isLoading
  })));

  function processProductActivation() {
    return _processProductActivation.apply(this, arguments);
  }

  function _processProductActivation() {
    _processProductActivation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              setLoading(true);
              _context.t0 = productStatus;
              _context.next = _context.t0 === PRODUCT_STATUS.CAN_ACTIVATE ? 5 : _context.t0 === PRODUCT_STATUS.ACCESS_NEEDED ? 10 : 15;
              break;

            case 5:
              _context.next = 7;
              return activateProduct(environment, swicusOrgId, targetProduct, originProduct);

            case 7:
              goToProduct(swicusOrgId, environment, targetProduct);
              closeModal();
              return _context.abrupt("break", 16);

            case 10:
              _context.next = 12;
              return requestAccess(environment, swicusOrgId, targetProduct, originProduct);

            case 12:
              setIsAccessRequested(true);
              setMessageType('success');
              return _context.abrupt("break", 16);

            case 15:
              setMessageType('error');

            case 16:
              _context.next = 22;
              break;

            case 18:
              _context.prev = 18;
              _context.t1 = _context["catch"](0);
              setMessageType('error');
              /* eslint-disable-next-line no-console */

              console.error("Activation product \"".concat(targetProduct, "\" failed with error: ").concat(_context.t1));

            case 22:
              setLoading(false);

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 18]]);
    }));
    return _processProductActivation.apply(this, arguments);
  }

  function getContactLink() {
    var product = appList.find(function (app) {
      return app.id === targetProduct;
    });

    if (product) {
      return /*#__PURE__*/React.createElement("a", {
        href: product.url.contact
      }, "contact support");
    } else {
      return 'contact support';
    }
  }

  function closeModal() {
    onClose();
    setIsAccessRequested(false);
    setMessageType('');
  }
};

var ActionButtons = function ActionButtons(_ref) {
  var targetProduct = _ref.targetProduct,
      onClose = _ref.onClose,
      productStatus = _ref.productStatus,
      onActionButtonClick = _ref.onActionButtonClick,
      isLoading = _ref.isLoading,
      isAccessRequested = _ref.isAccessRequested;
  var product = appList.find(function (app) {
    return app.id === targetProduct;
  });
  var productHomepageLink = product ? product.url.homepage : undefined;

  if (productHomepageLink && (productStatus === PRODUCT_STATUS.CAN_ACTIVATE || productStatus === PRODUCT_STATUS.ACCESS_NEEDED)) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      basic: true,
      className: "close-button",
      onClick: onClose
    }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
      as: "a",
      basic: true,
      "data-qa": "learn-more-link",
      href: productHomepageLink,
      target: "_blank"
    }, "Learn more"), /*#__PURE__*/React.createElement(ActionButton, {
      productStatus: productStatus,
      targetProduct: targetProduct,
      onActionButtonClick: onActionButtonClick,
      isLoading: isLoading,
      isAccessRequested: isAccessRequested
    }));
  }

  return /*#__PURE__*/React.createElement(Message, {
    error: true,
    content: "Something went wrong",
    "data-qa": "error"
  });
};

var ActionButton = function ActionButton(_ref2) {
  var productStatus = _ref2.productStatus,
      targetProduct = _ref2.targetProduct,
      onActionButtonClick = _ref2.onActionButtonClick,
      isLoading = _ref2.isLoading,
      isAccessRequested = _ref2.isAccessRequested;
  return /*#__PURE__*/React.createElement(Button, {
    primary: true,
    "data-qa": "activation-button-".concat(targetProduct),
    loading: isLoading,
    disabled: isLoading || isAccessRequested,
    onClick: onActionButtonClick
  }, getTitleForActionButton(productStatus, isAccessRequested));
};

function getTitleForActionButton(status, isAccessRequested) {
  if (isAccessRequested) {
    return 'Access requested';
  }

  switch (status) {
    case PRODUCT_STATUS.CAN_ACTIVATE:
      return 'Start free trial';

    case PRODUCT_STATUS.ACCESS_NEEDED:
      return 'Request access';

    default:
      return 'Something went wrong';
  }
}

export function getCookie(cookieName) {
  var name = cookieName + '=';
  var cookiesArray = document.cookie.split(';');

  for (var i = 0; i < cookiesArray.length; i++) {
    var cookie = cookiesArray[i];

    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }

    if (cookie.indexOf(name) === 0) {
      var rawValue = cookie.substring(name.length, cookie.length); // URL-encoding is common but not required for cookies. Decode if
      // necessary, since url-parse will correctly encode the result.

      return decodeURIComponent(rawValue);
    }
  }

  return '';
}

function goToProduct(swicusOrgId, environment, productName) {
  var product = appList.find(function (app) {
    return app.id === productName;
  });
  var parsedUrl = parseUrl(product.url.login[environment], true);
  parsedUrl.query = {
    utm_source: productName,
    utm_medium: 'app_switcher',
    tracking_code: getCookie('SWI_Referral'),
    ref: getCookie('SWI_RefUrl')
  };
  if (swicusOrgId) parsedUrl.query.swicus_org_id = swicusOrgId;
  window.open(parsedUrl.toString());
}